export default async () => {
    await window.appInitializer.initTrainBannerApp()
}
